module.exports = __webpack_public_path__ + "media/images/icon__arrow-right--rb-light-gray@3x-9d4abb1971413016fe85431998094b29.png";